import { FormControl, FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedFormField } from '../../models/appliance-details-stepped/appliance-details-stepped-form-field.enum';
import { ApplianceDetailsSteppedForm } from '../../models/appliance-details-stepped/appliance-details-stepped-form.interface';
import { PersonalDetailsForm } from '../../models/appliance-details-stepped/personal-details-form.interface';
import { mockModelAndSerialNumberFieldset } from './model-and-serial-number-fieldset.mock';
import { mockPersonalDetailsForm } from './personal-details-form.mock';

export const mockApplianceDetailsSteppedForm: ApplianceDetailsSteppedForm = {
  [ApplianceDetailsSteppedFormField.ApplianceCategoryCode]: new FormControl(
    null
  ),
  [ApplianceDetailsSteppedFormField.ApplianceCode]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.BrandCode]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.ModelAndSerialNumber]: new FormGroup(
    mockModelAndSerialNumberFieldset
  ),
  [ApplianceDetailsSteppedFormField.PurchasePrice]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.PurchaseDate]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.PersonalDetails]:
    new FormGroup<PersonalDetailsForm>(mockPersonalDetailsForm),
};
